import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState } from 'react'
import { Spin } from 'antd'
import { DualAxes } from '@antv/g2plot';
import CardContainer from '@/pages/Bmjy/components/components/CardContainer'

const data = [];
const data1 = []

const LRV_KEY = '本年占比去年开票收入总数(%)'

for(let i=0; i<12; i++) {
  data.push({
    "label": i+ 1 + "所",
    "type": "本年开票收入(万)",
    "value": Math.floor(Math.random()*100)
  })
  data.push({
    "label": i+ 1 + "所",
    "type": "上年开票收入(万)",
    "value": Math.floor(Math.random()*100)
  })
  data1.push({
    "label": i+ 1 + "所",
    [LRV_KEY]: Math.floor(Math.random()*100)
  })
}

const tabsOptions = [
  {
    label: '按院', 
    value: 'ay',
    api: null
  }, 
  {
    label: '按所', 
    value: 'as',
    api: null
  }
]

type DataItem = {
  label: string
  value: number
}

type PropType = FC<PropsWithChildren<{
  bar1Label: string
  bar1Data: DataItem[]
  bar2Label: string
  bar2Data: DataItem[]
  lineLabel: string
  lineData: DataItem[]
  barUnit?: string
}>>

const Component: PropType = ({bar1Data, bar1Label, bar2Data, bar2Label, lineData, lineLabel, barUnit}) => {
  const containerRef = useRef()
  const globalRef = useRef({
    params: {
      tab: '',
      depart: ''
    },
    column: null as DualAxes,
  })

  // 渲染图表数据
  const renderChart = useCallback(() => {
    if(!globalRef.current.column) {
      return
    }
    const barData = [...bar1Data.map(r => ({
      ...r,
      type: bar1Label
    })), ...bar2Data.map(r => ({
      ...r,
      type: bar2Label
    }))]
    globalRef.current.column.changeData([barData, lineData.map(r => ({
      ...r,
      [lineLabel]: r.value
    }))])
  }, [bar1Data, bar2Data, lineData, lineLabel, bar1Label, bar2Label])

  useEffect(() => {
    globalRef.current.column = new DualAxes(containerRef.current, {
      data: [[], []],
      xField: 'label',
      yField: ['value', lineLabel],
      legend: {
        position: 'bottom',
      },
      yAxis: {
        value: {
          label: {
            formatter: (val) => {
              return `${val}${barUnit||''}`;
            },
          },
        },
        [lineLabel]: {
          label: {
            formatter: (val) => {
              return `${val}%`;
            },
          },
        },
      },
      geometryOptions: [
        {
          geometry: 'column',
          isGroup: true,
          seriesField: 'type',
          color: ({type}, defaultColor) => {
            if(type === bar2Label) {
              return '#5D7092'
            }
            return defaultColor
          }
        },
        {
          geometry: 'line',
          lineStyle: {
            lineWidth: 2,
          },
          color: '#63DAAB',
          point: {
            shape: 'circle',
            size: 4,
          }
        },
      ],
      
    });

    globalRef.current.column.render();
    renderChart()
  }, [])

  useEffect(() => {
    renderChart()
  }, [renderChart])

  return (
    <div className='h-full' ref={containerRef}></div>
  )
}

export default Component
